import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

interface RiderDropdownProps {
  options: { _id: string; id: string }[];
  placeholder: string;
  selectedId: string;
  onChange: (value: string) => void;
  emptyMessage?: string;
}

const RiderDropdown: React.FC<RiderDropdownProps> = ({
  options,
  placeholder,
  selectedId,
  onChange,
  emptyMessage = "No options available",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = options.find((opt) => opt._id === selectedId);

  return (
    <div className="relative w-full">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="w-full border border-gray-300 rounded p-2 flex justify-between items-center cursor-pointer bg-white"
      >
        <span className="truncate">{selectedOption?.id || placeholder}</span>
        <FontAwesomeIcon icon={faCaretDown} className="text-gray-500" />
      </div>

      {isOpen && (
        <div className="absolute z-10 w-full bg-white border border-gray-300 mt-1 rounded shadow-md max-h-60 overflow-y-auto">
          {options.length === 0 ? (
            <div className="p-2 text-sm text-gray-400">{emptyMessage}</div>
          ) : (
            options.map((option) => (
              <div
                key={option._id}
                onClick={() => {
                  onChange(option._id);
                  setIsOpen(false);
                }}
                className={`p-2 text-sm hover:bg-gray-100 cursor-pointer ${
                  option._id === selectedId ? "bg-gray-100 font-medium" : ""
                }`}
              >
                {option.id}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default RiderDropdown;
